import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-client-dialog',
  templateUrl: './delete-client-dialog.component.html',
  styleUrls: ['./delete-client-dialog.component.scss']
})
export class DeleteClientDialogComponent {
  @Input() clientName = '';
  typedName = '';

  constructor(public activeModal: NgbActiveModal) {}

  // Exact, case-sensitive match; surrounding whitespace is ignored on both sides
  get canDelete(): boolean {
    const expected = this.clientName.trim();
    return expected.length > 0 && this.typedName.trim() === expected;
  }

  confirm(): void {
    if (this.canDelete) {
      this.activeModal.close(true);
    }
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
